import { PageLinks } from "./page-links";

export const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

export const currency = process.env.GATSBY_CURRENCY;
export const country = "Horsforth";
export const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
export const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g,'-');

export const defaultArea_Newhomes = process.env.GATSBY_DEFAULT_AREA_NEWHOMES ? process.env.GATSBY_DEFAULT_AREA_NEWHOMES : "London";
export const defaultArea_Newhomes_Slug = defaultArea_Newhomes.toLowerCase().replace(/ /g,'-');

export const defaultResult_Link = "/find-a-property/";

export const site_name = process.env.GATSBY_SITE_NAME;
export const hasMyaccount = (process.env.GATSBY_MYACCOUNT || null) === '1' ? true : false;
export const postCodeAddressAPI = "ncZgV7m79UipxWpivISlAw37900";
export const hasPropertyCloud = (process.env.GATSBY_ENABLE_PROPERTYCLOUD || null) === '1' ? true : false;

export const IsAllAgentReview = true;
export const Default_View = "Grid"
export const slider_count = 3;
export const news_slider_count = 3;
export const site_bviewing_agent_id = ""

export const search_result_sidebar = false;

export const SimilarProperty_FullWdth = true;

export const currency_converter = false;

export const branch_filter = true;

export const viewing_btn_text = "Enquire";

export const apply_btn_text = "Apply for this role";

export const search_box_placeholder = "Location";

export const footerVatDetails = "Hardisty. is the trading name of Hardisty Brothers Limited which is registered in England & Wales.<br />Registered office address: 70 St. Mary Axe, London, EC3A 8BE.<br />Registered Company Number: 06485891. VAT Number: 928565975";

export const emailFooter = "Hardisty is the trading name of Hardisty Brothers Limited which is registered in England & Wales. Registered office address: 70 St. Mary Axe, London, EC3A 8BE. Registered Company Number: 06485891. VAT Number: 299705053 Part of Lomond";


export const mortgage_text = "This mortgage calculator is provided by Hardisty. Hardisty work with Mortgage Advice Bureau to give our clients access to expert mortgage and protection advice. Mortgage Advice Bureau have access to over 12,000 mortgages from 90+ lenders so they can find the right mortgage to suit your individual needs. Your home may be repossessed if you do not keep up repayments on your mortgage. There may be a fee for mortgage advice. The actual amount you pay will depend upon your circumstances. The fee is up to 1% but a typical fee is 0.3% of the amount borrowed."

export const valuation_thanks = `<p>We’ll be in touch shortly to arrange a suitable time for one of our Hardisty experts to visit and assess your property.<br /><br />
Looking to buy a property? Browse listings <a href="/${PageLinks.property_for_sale}/">here</a>.</p>
<h4>Your Hardisty Account</h4>
<p>Receive a tailored report with up-to-date insights into your home’s value and the current market in your area.</p>`

export const marketing_consent = `I agree to receive property-related news, updates and communications from ${process.env.GATSBY_SITE_NAME}. I understand I can unsubscribe at any time.`

export const terms_condition_text = `By submitting this form, you confirm that you agree to our website <a href="/${PageLinks.terms_condition}/" target="_blank">terms and conditions</a>, <a href="/${PageLinks.privacy_policy}/">privacy policy</a> and <a href="/${PageLinks.cookie_policy}/">cookie policy</a>. <br /><br />This site is protected by reCAPTCHA and the Google <a href="/${PageLinks.privacy_policy}/">Privacy Policy</a> and <a href="/${PageLinks.terms_condition}/" target="_blank">Terms of Service</a> apply.`

export const Mail_Vars = {
    fb_link: "https://www.facebook.com/hardistyandco/",
    tw_link: "https://x.com/hardistyandco",
    company_phone: "0113 4874526",
    available_time: "We're available from 9am - 5:30pm Monday to Friday, 9am - 4pm Satrurday, 11am - 3pm Sunday",
    address: "70 St. Mary Axe, London, EC3A 8BE."
}

// export const PageLinks = {
//     about: "about-brandvaughan",
//     general_enquiry: "general-enquiry",
//     news_insight: `about-brandvaughan/insights`,
//     branch_finder: "about-brandvaughan/branch-finder",
//     area_cover: "about-brandvaughan/areas-we-cover",
//     branch_contact: "contact-us",
//     team_contact: "contact-us",
//     teams: "about-brandvaughan/meet-the-team",
//     request_valuation: "property-valuation",
//     privacy_policy: "privacy-policy",
//     book_a_viewing: "book-a-viewing",
//     book_a_valuation: "property-valuation/home-visit-valuation",
//     send_to_friend: "send-to-friend",
//     property_to_rent: "property/to-rent",
//     property_for_sale: "property/for-sale",
//     reviews: "about-brandvaughan/customer-reviews",
//     property_management: "landlords/property-management",
//     financial_services: `financial-services`
// }

export const PropertySearchURL = {
    residential: {
        sales:"/property/for-sale/",
        lettings:"/property/to-rent/",
        newhomes: "/new-homes/for-sale/",
        newdevelopments: "/new-developments/for-sale/",
        investments: "/property-investments/for-sale/",
        students: "/property-students/to-rent/",
        collection: "/property-collection/for-sale/"
    },
    commercial: {
        sales:"/commercial-property/for-sale/",
        lettings:"/commercial-property/to-rent/",
    },
    auction: {
        sales:"/auctions/for-sale/"
    }
}

export const PropertyDetailsURL = {
    residential: {
        sales:"/property-for-sale/",
        lettings:"/property-to-rent/",
        newhomes:"/property-for-sale/",
        newdevelopments:"/new-developments-for-sale/"
    },
    commercial: {
        sales:"/commercial-property-for-sale/",
        lettings:"/commercial-property-to-rent/",
    },
    auction: {
        sales:"/auction-for-sale/"
    }
}

export const SearchTitle = {
    residential: {
        sales:"Properties for sale",
        lettings:"Properties to rent",
        newhomes:"New homes",
        newdevelopments:"New developments",
        investments: "Investment properties for sale",
        students:"Student properties for sale",
    },
    commercial: {
        sales:"Commercial properties for sale",
        lettings:"Commercial properties to rent",
    },
    auction: {
        sales:"Auction properties for sale"
    }
}

export const PopularSearch_Areas = [ 
    { value: "horsforth", label: "Horsforth" },
    { value: "armley", label: "Leeds" },
    { value: "pudsey", label: "Pudsey" },
    { value: "bradford", label: "Bradford" }   
]

export const PopularSearch_Types = [ 
    { value: "house", label: "Houses" },
    { value: "apartment", label: "Apartments" },
    { value: "bungalow", label: "Bungalows" },
    { value: "maisonette", label: "Maisonettes" }   
]

export const sortByList = [ 
    { value: "Newest", label: "Newest" },
    { value: "HighestPrice", label: "Highest Price" },
    { value: "LowestPrice", label: "Lowest Price" },
    { value: "Oldest", label: "Oldest" },
]

export const SearchType = {
    sales:"For Sale",
    lettings:"To Rent",
    newhomes:"New homes",
    investments:"Investments",
    students:"Students",
    commercial_sales:"Commercial Sales",
    commercial_lettings:"Commercial Lettings",
    auction_sales:"Auctions",
    collection:"Exclusive",
    newdevelopments:"Developments",
}

export const FurnishedType = [    
    { value: '', label: 'Select type' },
    { value: 'furnished', label: 'Furnished' },
    { value: 'unfurnished', label: 'Unfurnished' },
    { value: 'part-furnished', label: 'Part furnished' },
]

export const leadooPageSlot = {
    sell_property:"Sellers",
    landlords:"Landlords",
    sales:"Sale listings",
    lettings:"Rental listing",
    branch_finder:"Branch finder",
    general_enquiry:"General enquiry",
    valuation:"Valuation",
    home:"Valuation"
}
